import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './MoreChild.module.scss';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cardData from './card-data';
import techStackData from './service-data';
import { Link } from 'react-router-dom';
const cx = classNames.bind(styles);

function MoreChild() {
    let { pathname } = useLocation();
    let [indexPage, setIndexPage] = useState(0);
    const { t } = useTranslation();
    const data = [
        {
            title: t('Ours Services'),
            titleTech: t('We offer a wide range spectrum'),
            titleContent: t('Our services will help'),
            poster: 'https://static.wixstatic.com/media/c794a2_19eb0da47f0746a2a842f79e3844f100f000.jpg/v1/fill/w_1519,h_552,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_19eb0da47f0746a2a842f79e3844f100f000.jpg',
            content: t('At Odyssey, we understand'),
            images: [
                'https://static.wixstatic.com/media/c794a2_73c443f86a7f45fe986dd87d1712c18c~mv2.jpg/v1/fill/w_358,h_419,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/roberto-cortese-ejhjSZKTeeg-unsplash.jpg',
                'https://static.wixstatic.com/media/c794a2_256812facd4346fcb14dca63d5a34c1d~mv2.jpg/v1/crop/x_1701,y_0,w_4497,h_5268/fill/w_358,h_419,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/person-working-html-computer.jpg',
                'https://static.wixstatic.com/media/c794a2_9632db8baf1b47b5abbc45d5a5c830b2~mv2.jpg/v1/crop/x_399,y_0,w_1122,h_1314/fill/w_358,h_419,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ai-generated-8211245_1920.jpg',
                require(`./../../assets/images/services/erp2.jpg`),
                '/videos/services/it_staff.png',
                '/videos/services/positive-senior-leader-drawing-graph-meeting.png',
            ],
            link: [
                '/digital-transformation',
                '/outsourcing',
                '/it-consulting',
                '/erp-deployment',
                '/it-staffing',
                '/it-training'
            ],
            name: [t('Digital transformation'), t('Outsourcing'), t('IT consulting'), t('ERP Implementation'), t('IT staffing'), t('IT training')],
        },
        {
            title: t('Digital Transformation Services that Help Businesses Champion Change'),
            indexClass: 1,
            titleTech: t('We believe every business'),
            video: 'https://video.wixstatic.com/video/c794a2_442ef00b0f1645e28b82ce5d7e3ee3a4/720p/mp4/file.mp4',
            titleContent: t('Digital transformation'),
            poster: 'https://static.wixstatic.com/media/c794a2_442ef00b0f1645e28b82ce5d7e3ee3a4f000.jpg/v1/fill/w_761,h_532,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_442ef00b0f1645e28b82ce5d7e3ee3a4f000.jpg',
            content: t('Our digital business transformation services'),
        },
        {
            title: t('Exciting IT Outsourcing'),
            indexClass: 2,
            titleTech: t('Outsourced IT services enable you'),
            video: 'https://video.wixstatic.com/video/c794a2_335ed2899af5425c953ae39da5819c22/720p/mp4/file.mp4',
            titleContent: t('Outsourcing'),
            poster: 'https://static.wixstatic.com/media/c794a2_335ed2899af5425c953ae39da5819c22f000.jpg/v1/fill/w_761,h_532,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_335ed2899af5425c953ae39da5819c22f000.jpg',
            content: t('Outsourced IT services'),
        },
        {
            title: t('IT Consulting Build'),
            indexClass: 3,
            titleTech: t('With a team steeped in deep'),
            video: 'https://video.wixstatic.com/video/c794a2_9943cfb9cc4d48dfa8df9ac8cfc4848d/720p/mp4/file.mp4',
            titleContent: t('IT Consulting'),
            poster: 'https://static.wixstatic.com/media/c794a2_9943cfb9cc4d48dfa8df9ac8cfc4848df000.jpg/v1/fill/w_761,h_532,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_9943cfb9cc4d48dfa8df9ac8cfc4848df000.jpg',
            content: t('We are committed to delivering'),
        },
        {
            title: t('Optimize every aspect of'),
            indexClass: 4,
            titleTech: t('We offer comprehensive ERP solutions'),
            video: '/videos/services/video_erp.mp4',
            titleContent: t('ERP Implementation'),
            poster: '/videos/services/erp.png',
            content: t('We implement the best ERP system'),
        },
        {
            title: t('Optimize your cost by utilizing our IT staffing service'),
            indexClass: 4,
            titleTech: t('Our IT staffing service'),
            video: '/videos/services/it_staff.mp4',
            titleContent: t('IT staffing'),
            poster: '/videos/services/it_staff_poster.png',
            content: t('We offer a dynamic workforce solution'),
        },
    ];

    useEffect(() => {
        if (pathname === '/services') {
            setIndexPage(0);
        } else if (pathname === '/digital-transformation') {
            setIndexPage(1);
        } else if (pathname === '/outsourcing') {
            setIndexPage(2);
        } else if (pathname === '/it-consulting') {
            setIndexPage(3);
        } else if (pathname === '/erp-deployment') {
            setIndexPage(4);
        } else if (pathname === '/it-staffing') {
            setIndexPage(5);
        }
    }, [pathname]);

    return (
        <div className={cx('solution')}>
            {pathname === '/services' ? (
                <>
                    <div className={cx('solution__intro')}>
                        <div
                            className={cx('solution__intro-wraper')}
                            style={{ position: 'absolute', maxWidth: '798px', left: '105px', bottom: ' 43px' }}
                        >
                            <div className={cx('solution__intro__title')}>{data[0].title}</div>
                            <div className={cx('solution__intro__description-service')}>{data[0].titleTech}</div>
                        </div>
                    </div>
                    <div style={{ background: '#141416' }}>
                        {window.innerWidth > 768 ? (
                            <video autoPlay muted loop className={cx('desktop-video')}>
                                <source
                                    src="https://video.wixstatic.com/video/c794a2_19eb0da47f0746a2a842f79e3844f100/720p/mp4/file.mp4"
                                    type="video/mp4"
                                />
                            </video>
                        ) : (
                            <img style={{ width: '100%' }} src="https://static.wixstatic.com/media/c794a2_19eb0da47f0746a2a842f79e3844f100f000.jpg/v1/fill/w_1519,h_552,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_19eb0da47f0746a2a842f79e3844f100f000.jpg" alt="Mobile Image" className="mobile-image" />
                        )}
                    </div>
                    <div className={cx('solution__new')} style={{ background: 'rgb(27, 28, 30)' }}>
                        <div className={cx('solution__new__top')}>
                            <div className={cx('solution__new__top__text')}>{data[0].titleContent}</div>
                            <div className={cx('solution__new__top__text-two')}>{data[0].content}</div>
                        </div>
                    </div>
                    <div className={cx('solution__new', 'solution__new--three')}>
                        <div className={cx('solution__new__bottom')}>
                            {data[0].images.map((item, index) => (
                                <NavLink to={data[0].link[index]} key={index}>
                                    <div className={cx('image-container')}>
                                        <img src={item} alt={`Image ${index}`} style={{ objectFit: "cover" }} />
                                        <div className={cx('name-container')}>{data[0].name[index]}</div>
                                    </div>
                                </NavLink>
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={cx('solution__intro')}>
                        <div
                            className={cx('solution__intro-wraper')}
                            style={{
                                position: 'absolute',
                                maxWidth: '900px',
                                left: '110px',
                                top: '26px',
                            }}
                        >
                            <div className={cx('solution__intro__title')}>{data[indexPage].title}</div>
                            <div className={cx('solution__intro__description')}>{data[indexPage].titleTech}</div>
                        </div>
                    </div>

                    <div className={cx('solution__new', 'solution__new-service-' + data[indexPage].indexClass)}>
                        <div className={cx('solution__new__top')}>
                            <div className={cx('solution__new__top__content')}>{data[indexPage].titleContent}</div>
                            <div className={cx('solution__new__top__content-two')}>
                                <p>{data[indexPage].content}</p>
                            </div>
                        </div>
                        <div>
                            {window.innerWidth > 768 ? (
                                <video
                                    crossOrigin="anonymous"
                                    playSinline="true"
                                    preload="auto"
                                    loop
                                    tabIndex="-1"
                                    autoPlay
                                    muted
                                    src={data[indexPage].video}
                                    className="desktop-video"
                                    style={{ width: '800px', maxWidth: '100%' }}
                                ></video>
                            ) : (
                                <img style={{ width: '100%' }} src={data[indexPage].poster} alt="Mobile Image" />
                            )}
                        </div>
                    </div>
                    {indexPage === 5 && (
                        <div className={cx('solution__staffing-highlight')}>
                            <div className={cx('solution__staffing-highlight__title')}>
                                {t('We provide the right people for your problems')}
                            </div>
                            <div className={cx('solution__staffing-highlight__desc')}>
                                {t('Our IT staffing service help you')}
                            </div>

                            <div className={cx('card-grid-section')}>
                                {cardData.cards.map((card, index) => (
                                    <div className={cx('card-grid-item')} key={index}>
                                        <img src={card.image} alt={card.title} />
                                        <h4>{card.title}</h4>
                                        <p>{t(card.desc)}</p>
                                    </div>
                                ))}
                            </div>

                            {/* Tech Stack Section */}
                            <div className={cx('tech-section')}>
                                <div className={cx('tech-title')}>
                                    <div className={cx('column')}>
                                        <h1>{t('Our IT staffing services are')}</h1>
                                    </div>
                                    <div className={cx('column')}>
                                        <div className={cx('tech-description')}>
                                            <p>{t('Our IT staff augmentation services')}</p>
                                        </div>
                                        <div className={cx('button-wrapper')}>
                                            {/* <div href="/contact" className={cx('book-now')}>
                                                <Link
                                                    to="/contact"
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                >
                                                    {t('Book now')}
                                                </Link>
                                            </div> */}
                                            <Link to="/contact" className={cx("solution__cta__button")}>
                                                {t("CONTACT US >")}
                                            </Link>
                                        </div>
                                    </div>

                                    <div className={cx('tech-item')}>
                                        {techStackData.map((tech, index) => (
                                            <div className={cx('tech-icon')} key={index}>
                                                <img src={tech.img} alt={tech.name} />
                                                <h1>{tech.name}</h1>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={cx('it-provider')}>
                                <div className={cx('it-provider-highlight')}>
                                    <div className={cx('it-provider-highlight__title')}>
                                        {t('We provide IT human')}
                                    </div>
                                    <div className={cx('it-provider-highlight__desc')}>
                                        {t('We can provide personnel')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default MoreChild;
